import { Text } from "@chakra-ui/react";
import { WriteCommentModalShell } from "src/components/modals/write-comment-modal/write-comment-modal-shell";
import { stripHtml } from "src/utils/html/strip-html";

export interface INewsWriteCommentModalSaveParams {
    entityId: string;
    message: string;
    parentCommentId?: string;
    commentId?: string;
}

export interface IParentComment {
    commentId: string;
    message: string;
}

export interface INewsWriteCommentModalContent {
    content: string;
    characterCountLimit?: number;
    editorPlaceholder: string;
    isPendingSave: boolean;
    parentComment?: IParentComment;
    entityId: string;
    onSave?: (saveParams: INewsWriteCommentModalSaveParams) => void;
}

export const NewsWriteCommentModalContent = ({
    content,
    characterCountLimit,
    editorPlaceholder,
    isPendingSave,
    parentComment,
    entityId,
    onSave,
}: INewsWriteCommentModalContent) => {
    const parentCommentPreview = stripHtml({ html: parentComment?.message });

    return (
        <WriteCommentModalShell
            content={content}
            characterCountLimit={characterCountLimit}
            editorPlaceholder={editorPlaceholder}
            isPendingSave={isPendingSave}
            articlePreviewUrl={undefined}
            autofocus={true}
            onSave={({ content: newContent }) => {
                onSave?.({
                    message: newContent,
                    // Dev Note: either is root comment or a reply
                    entityId: entityId,
                    ...(parentComment?.commentId ? { parentCommentId: parentComment.commentId } : {}),
                });
            }}
        >
            {parentComment && parentCommentPreview && (
                <Text pl={1} mb={2} borderLeft="2px" color="gray.600" borderColor="gray.200" noOfLines={[2, 1]} overflow="hidden" fontSize="sm">
                    {parentCommentPreview}
                </Text>
            )}
        </WriteCommentModalShell>
    );
};
